// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';
import DetailedDatesDisclaimer from './DetailedDatesDisclaimer';

// Utils
import { getDetailedHoldingsAsAtDates, getHoldingsAsAtDates } from '@/utils/disclaimers/comparison';
import { formatMessageWithLocale } from '@/utils/i18n';

// Types
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  detailed?: boolean;
  locale?: Locale;
  showItemNames?: boolean;
}

const YieldDisclaimer = ({ items, detailed, locale, showItemNames }: Props) => {
  if (detailed) {
    return (
      <DetailedDatesDisclaimer
        showItemNames={showItemNames}
        globalPrefix={formatMessageWithLocale('Disclaimers.Yield', locale)}
        itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
        itemDates={getDetailedHoldingsAsAtDates(items, locale)}
        locale={locale}
      />
    );
  }
  return (
    <DatesDisclaimer
      globalPrefix={formatMessageWithLocale('Disclaimers.Yield', locale)}
      itemDates={getHoldingsAsAtDates(items, locale)}
      itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
      locale={locale}
      showItemNames={showItemNames}
    />
  );
};

export default YieldDisclaimer;
